import React from 'react';
import * as Ons from 'react-onsenui';
import { READY_TO_PLAY, ROSTERS_LOCKED, ROSTERS_UNLOCKED} from '../../store/constants/statusCodes';
import { getRosterPublicStatusIcon } from '../../util';
import { translate as _ } from '../../util/i18n';

class Game extends React.Component {

    renderTeamName( team ) {

        return <>{this.props.game[ team + 'Team' ].shortName}{getRosterPublicStatusIcon( this.props.context, this.props.game, team )}</>;

    }

    render() {

        return (

            <Ons.ListItem modifier={this.props.modifier} tappable={true} onClick={() => this.props.onClick( this.props.game )}>

                <div className="left"><span className="id">{this.props.game.timeIsToBeDetermined ? _( 'TBD' ) : this.props.game.scheduledTime}</span></div>

                <div className="center">{this.renderTeamName( 'home' )} - {this.renderTeamName( 'away' )}</div>

                <div className="right">

                    {

                        this.props.game.rosterStatus === READY_TO_PLAY ?

                            <Ons.Icon icon='fa-play' />

                        : this.props.game.rosterStatus === ROSTERS_LOCKED ?

                            <Ons.Icon icon='fa-lock' />

                        : this.props.game.rosterStatus === ROSTERS_UNLOCKED ?

                            <Ons.Icon icon='fa-chevron-right' />

                        : <Ons.Icon icon='fa-ban' />

                    }

                </div>

            </Ons.ListItem>

        );

    }

}

export default Game;